<template>
  <div class="categorizedProductDisplay">
    <div class="categorizedHeader">
      <div class="categorizeTitle">Selected products</div>
      <div class="categorizeBtn">
        <span>More</span>
        <span class="categorizeIcon"><i class="el-icon-arrow-right"></i></span>
      </div>
    </div>
    <div class="categorizedList">
      <div
        :class="[
          'categorizedItem',
          item.name == categorizedValue ? 'categorizedItemSelected' : '',
        ]"
        v-for="(item, index) in categorizedList"
        :key="index"
        @click="categorizedClick(item.name)"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="categorizedProductBox">
      <div
        class="categorizedProduct"
        v-for="(item, index) in list"
        :key="index"
        @click.stop="goProduct(item)"
      >
        <div class="ProductImgBox">
          <img class="ProductImg" :src="getMainImg(item.imageText)" alt="" />
        </div>
        <div class="ProductIntroduction">
          <div class="ProductTitle">{{ item.subject }}</div>
          <div class="ForSale">
            <div class="Productprice">CN ￥{{ item.sellingMinPrice }}</div>
            <div class="Productshop">MOQ: {{ item.minOrderQuantity || 1 }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { Page } from '@/request/api/Home/categorizedProductDisplayTwo';
import { useToast } from 'vue-toastification';

const router = useRouter();
const toast = useToast();

// 响应式数据
const categorizedList = ref([
  { name: 'All' },
  { name: 'Yiwubuy Selected' },
  { name: 'Toys, Babies & Kids' },
  { name: 'Fashion Jewelry & Accessories' },
  { name: 'Apparel & Accessories' },
  { name: 'Shoes & Accessories' },
  { name: 'Daily Necessities' },
  { name: 'Home Appliances' },
  { name: 'Beauty & Personal Care' },
  { name: 'Luggage, Bags & Cases' },
  { name: 'Consumer Electronics' },
  { name: 'Sports & Entertainmen' },
]);

const list = ref([]);
const categorizedValue = ref('All');
const listQuery = ref({
  pageSize: 60,
  page: 1,
  keyword: '',
});
const total = ref(0);

// 方法
const goProduct = (item) => {
  router.push({
    path: '/goods',
    query: { id: item.objectId },
  });
};

const getMainImg = (json) => {
  try {
    const list = json ? JSON.parse(json) : [];
    if (list.length > 0) {
      return list[0];
    }
  } catch (error) {
    return '';
  }
};

const categorizedClick = (value) => {
  categorizedValue.value = value;
};

const getList = () => {
  const params = {
    ...listQuery.value,
    keyword: categorizedValue.value == 'All' ? '' : '',
  };

  Page(params).then((res) => {
    const data = res.data;
    if (data.code == 0) {
      console.log('列表', data);
      list.value = data.data.productList;
      total.value = data.data.total;
    } else {
      // 这里需要根据你的实际项目中的 toast 实现来调整
      toast.error(`产品列表获取失败:${data.message}`, {
        position: 'top-right',
        timeout: 3000,
      });
      console.error(`产品列表获取失败:${data.message}`);
    }
  });
};

// 生命周期
onMounted(() => {
  getList();
});
</script>

<style lang="less" scoped>
.categorizedProductDisplay {
  color: #333;
  .categorizedHeader {
    display: flex;
    justify-content: space-between;
    .categorizeTitle {
      color: #333;
      font-size: 24px;
      font-weight: 400;
    }
    .categorizeBtn {
      font-size: 18px;
      color: #333;
      padding-right: 14px;
      display: flex;
      .categorizeIcon {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
  .categorizedList {
    font-size: 16px;
    color: #333;
    .categorizedItem {
      margin-right: 35px;
      line-height: 30px;
      cursor: pointer;
    }
    .categorizedItem:hover {
      color: #f60;
    }
    .categorizedItemSelected {
      color: #f60;
      font-weight: bold;
      border-bottom: 2px solid #f60;
    }
    display: flex;
    flex-wrap: wrap;
  }
  .categorizedProductBox {
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .categorizedProduct {
      cursor: pointer;
      width: 230px;
      border-radius: 5px;
      overflow: hidden;
      background-color: #fff;
      margin-bottom: 10px;
      .ProductImgBox {
        width: 220px;
        height: 230px;
        display: flex;
        justify-content: center;

        .ProductImg {
          width: 100%;
          height: 100%;
        }
      }
      .ProductIntroduction {
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-top: 20px;
        padding: 6px;
        .ProductTitle {
          width: 220px;
          height: 38px;
          font-size: 14px;
          font-weight: 400;
          color: #3a3a3a;

          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .Productprice {
          margin-top: 20px;
          font-size: 14px;
          font-weight: 700;
          color: #cc0e11;
        }
        .Productshop {
          margin-top: 20px;
          font-size: 12px;
          font-weight: 400;
          color: #999;
        }
        .ForSale {
          display: flex;
          justify-content: space-between;
          width: 100%;
          padding: 3px 6px;
        }
      }
    }
  }
}
</style>
